"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserLS = exports.deleteUserLS = exports.saveUserLS = exports.USER_KEY_LS = void 0;
exports.USER_KEY_LS = 'user';
const saveUserLS = (user) => localStorage.setItem(exports.USER_KEY_LS, JSON.stringify(user));
exports.saveUserLS = saveUserLS;
const deleteUserLS = () => localStorage.removeItem(exports.USER_KEY_LS);
exports.deleteUserLS = deleteUserLS;
const getUserLS = () => {
    const user = localStorage.getItem(exports.USER_KEY_LS);
    if (!user)
        return null;
    try {
        return JSON.parse(user);
    }
    catch (_a) {
        (0, exports.deleteUserLS)();
    }
    return null;
};
exports.getUserLS = getUserLS;
